import { defineAbility } from '@casl/ability'

import { User } from '../../../models'
import { Roles, userHasRole } from '../../../helpers'

export default (user: User) =>
    defineAbility((can) => {
        if (userHasRole(user, Roles.Lead)) {
            can('Create', 'SupplierBrand')
        }

        if (userHasRole(user, Roles.Executive)) {
            can('Edit', 'SupplierBrand')
        }

        if (userHasRole(user, Roles.Standard)) {
            can('View', 'SupplierBrand')
        }
        if (userHasRole(user, Roles.SrLead)) {
            can(['Create', 'Delete'], 'SupplierBrand')
        }
    })
